
document.addEventListener('DOMContentLoaded',()=>{
  const drawer=document.querySelector('.cart-drawer');
  const openCart=()=>drawer&&drawer.classList.add('is-open');
  const closeCart=()=>drawer&&drawer.classList.remove('is-open');
  document.querySelectorAll('.cart-trigger').forEach(x=>x.addEventListener('click',openCart));
  document.querySelectorAll('.drawer-close,.cart-drawer__backdrop').forEach(x=>x.addEventListener('click',closeCart));

  document.querySelectorAll('[data-countdown]').forEach(el=>{
    const target=new Date(el.dataset.countdown).getTime();
    const tick=()=>{
      const remaining=Math.max(0,target-Date.now());
      const D=Math.floor(remaining/86400000);
      const H=Math.floor(remaining/3600000)%24;
      const M=Math.floor(remaining/60000)%60;
      const S=Math.floor(remaining/1000)%60;
      el.textContent=remaining<=0?'CAMPANHA TERMINADA':`${String(D).padStart(2,'0')} DIAS ${String(H).padStart(2,'0')} HORAS ${String(M).padStart(2,'0')} MIN ${String(S).padStart(2,'0')} SEG`;
    };
    tick();
    setInterval(tick,1000);
  });

  const mobileNav=document.querySelector('.mobile-nav');
  const mobileButton=document.querySelector('.mobile-menu');
  const closeMobile=()=>{
    if(!mobileNav)return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden','true');
    mobileButton?.setAttribute('aria-expanded','false');
    document.body.classList.remove('nav-open');
  };
  const openMobile=()=>{
    if(!mobileNav)return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden','false');
    mobileButton?.setAttribute('aria-expanded','true');
    document.body.classList.add('nav-open');
  };
  mobileButton?.addEventListener('click',openMobile);
  mobileNav?.querySelector('.mobile-nav__close')?.addEventListener('click',closeMobile);
  mobileNav?.querySelector('.mobile-nav__backdrop')?.addEventListener('click',closeMobile);
  mobileNav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMobile));

  mobileNav?.querySelectorAll('.mobile-nav__toggle').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const item=btn.closest('.mobile-nav__item--parent');
      if(!item)return;
      const isOpen=item.classList.contains('is-open');
      mobileNav.querySelectorAll('.mobile-nav__item--parent.is-open').forEach(other=>{
        if(other!==item){
          other.classList.remove('is-open');
          other.querySelector('.mobile-nav__toggle')?.setAttribute('aria-expanded','false');
        }
      });
      item.classList.toggle('is-open',!isOpen);
      btn.setAttribute('aria-expanded',String(!isOpen));
    });
  });

  // Galeria de produto: grande, responsiva e com thumbnails.
  const gallery=document.querySelector('.product-gallery--large');
  if(gallery){
    const hero=gallery.querySelector('.product-gallery__hero-image');
    const thumbs=[...gallery.querySelectorAll('[data-product-thumb]')];
    thumbs.forEach((thumb,index)=>{
      thumb.addEventListener('click',()=>{
        const source=thumb.querySelector('img');
        if(!source||!hero)return;
        hero.src=thumb.dataset.fullImage || source.currentSrc || source.src;
        hero.removeAttribute('srcset');
        thumbs.forEach(t=>t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  // Produtos vistos recentemente, guardados localmente no navegador.
  const recentEl=document.querySelector('[data-recently-viewed]');
  if(recentEl){
    const handle=recentEl.dataset.recentlyViewed;
    try{
      const key='laceup_recent_products';
      const list=JSON.parse(localStorage.getItem(key)||'[]').filter(Boolean);
      const next=[handle,...list.filter(x=>x!==handle)].slice(0,5);
      localStorage.setItem(key,JSON.stringify(next));
      const others=next.filter(x=>x!==handle);
      if(others.length){
        recentEl.classList.add('is-visible');
        const grid=recentEl.querySelector('[data-recently-viewed-grid]');
        // A Shopify não expõe títulos/URLs de produtos arbitrários no cliente sem uma chamada.
        // Carregamos os cartões através da API pública de recomendação da loja.
        fetch(`/recommendations/products.json?product_id=${recentEl.dataset.productId}&limit=4`)
          .then(r=>r.ok?r.json():null)
          .then(data=>{
            if(!data?.products?.length||!grid)return;
            grid.innerHTML=data.products.slice(0,4).map(p=>`
              <a class="product-card" href="${p.url}">
                <div class="product-media">
                  ${p.featured_image?`<img class="product-png" src="${p.featured_image}" alt="${p.title.replace(/"/g,'&quot;')}">`:''}
                </div>
                <div class="product-info"><h3>${p.title}</h3><div class="product-bottom"><strong>${(p.price/100).toLocaleString('pt-PT',{style:'currency',currency:'EUR'})}</strong></div></div>
              </a>`).join('');
          }).catch(()=>{});
      }
    }catch(e){}
  }

  // Easter egg discreto: escreve LACEUP para ativar uma micro-interação.
  let code='';
  document.addEventListener('keydown',e=>{
    code=(code+e.key.toUpperCase()).slice(-6);
    if(code==='LACEUP')document.body.classList.toggle('easter-mode');
  });
});
